import { SxProps } from '@mui/material/styles';

export const appBarButtonSx: SxProps = {
  color: 'text.secondary',
  fontWeight: 'normal',
  '&:visited, &:focus, &:active': {
    color: 'text.secondary',
    backgroundColor: 'transparent',
  },
  alignItems: 'center',
};

export const appBarButtonSxMobile: SxProps = { ...appBarButtonSx, '& .MuiButton-startIcon': { margin: 0 } };

export const rowFlex: SxProps = { display: 'flex', flexDirection: 'row' };

export const columnFlex: SxProps = { display: 'flex', flexDirection: 'column' };

export const centerAlignment: SxProps = {
  alignItems: 'center',
  justifyContent: 'center',
};

export const centerAlignmentWithSpaceBetween: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const reportGridContainer = {
  ...columnFlex,
  gap: 3,
};
export const textFieldNoUnderlineSx: SxProps = {
  '& .MuiInput-underline:before': {
    borderBottom: 'none',
  },
  '& .MuiInput-underline:after': {
    borderBottom: 'none',
  },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottom: 'none',
  },
};

export const textFieldNoUnderlineWithMarginSx: SxProps = {
  ...textFieldNoUnderlineSx,
  marginBottom: '20px',
};

export const fullWidthInlineBlock: SxProps = {
  display: 'inline-block',
  width: '100%',
};

export const pagePadding: SxProps = {
  p: 4,
};

export const overflowEllipsis: SxProps = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  display: 'inline-block',
  textOverflow: 'ellipsis',
};
